import React from "react"
import ButtonMaterial from "@material-ui/core/Button"
import styled from "styled-components"

export const StyledDeleteButton = styled(ButtonMaterial)`
  height: 33px;
  border-radius: 4px;
  margin: 8px;
  min-width: 90px;
  transition: all 400ms ease;

  // &.btn-primary {
  //   background-color: var(--primaryColor);
  //   color: var(--white);
  //   border: 1.5px solid var(--primaryColor);

  //   &.Mui-disabled {
  //     border: 1.5px solid #ccc;
  //     color: #000;
  //     background-color: #ccc;
  //   }
  // }

  // &.btn-secondary {
  //   background-color: transparent;
  //   color: var(--primaryColor);
  //   border: 1.5px solid var(--primaryColor);

  //   &.Mui-disabled {
  //     border: 1.5px solid #ccc;
  //     color: #ccc;
  //     background-color: transparent;
  //   }
  // }

  /* New Delete Button */
 &.btn-delete {
  background-color: transparent !important;
  color: #e53935 !important;
  border: 1.5px solid #e53935 !important;

  &:hover {
    background-color: transparent !important;
    color: #e53935 !important;
    border-color: #e53935 !important;
  }

  &.Mui-disabled {
    background-color: transparent !important;
    border: 1.5px solid #ccc !important;
    color: #ccc !important;
  }
}

  &:hover {
    transform: scale(1.03);
  }

  &:active {
    transform: scale(0.97);
  }
`

const DeleteButtonUI = (props) => {
  const {
    title = "SAVE",
    typeView = "delete",
    isDeleteAllowed = true,
    ...restProps
  } = props || {}


  if (isDeleteAllowed === false) {
    return <></>; // Don't render the button if delete is not allowed
  }
  return (
    <StyledDeleteButton
      className={`btn-${typeView}`}
      {...restProps}
    >
      {title}
    </StyledDeleteButton>
  )
}

export { DeleteButtonUI }
export default DeleteButtonUI
